<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>確定使用量再取込画面</h1>
<!-- Select what to search -->
<mat-accordion class="expantion-style">
    <mat-expansion-panel class="sg-search-condition-expansion" [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="title">検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div>
            <form [formGroup]="reimportUsageConditionForm">
                <app-sgkc051d-search-condition (onClickSearchEvent)="onClickSearch()"
                    (onClickClearEvent)="onClickClear($event)"
                    [inputStatusList]="statusList"></app-sgkc051d-search-condition>
            </form>
        </div>
    </mat-expansion-panel>
</mat-accordion>

<div *ngIf="showResult && reimportTargetListResult.length > 0">
    <mat-card class="cur-card">
        <app-sgkc051d-search-result (onClickRegistrationEvent)="onClickRegistration($event)"
            [reimportTargetListResult]="reimportTargetListResult" [inputStatusList]="statusList"
            [inputSuppntSpno]="suppntSpno"></app-sgkc051d-search-result>
    </mat-card>
</div>